
import { CertificateInfo } from '@luxtag/papybase';
import { find, findIndex } from 'lodash';

export const MUTATE_PRODUCTS = 'MUTATE_PRODUCTS';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';


export interface ProductUIInfoFuse {
    item: ProductUIInfo;
    matches: any[];
    score?: number;
}

export interface ProductUIInfo {
    id: number | string;
    name?: string;
    serialNumber?: string;
    imgs?: string[];
    img: string;
    time?: string;
    date?: string;
    owner?: string;
    address?: string;
    privateKey?: string;
    publicKey?: string;
    uuid?: string;
    printStatus?: string;
    details?: string;
    status?: string;
}

interface ProductStore {
    products: CertificateInfo[];
}

// initial state
const productState: ProductStore = {
    products: [],
};

// getters
const getters = {
    getProducts: (state: ProductStore) => state.products,
    getProduct: (state: ProductStore) => (id: number) => find(
        state.products, (product: CertificateInfo) => product.id === id,
    ),
    getProductByAddress: (state: ProductStore) => (address: string) => find(
        state.products, (product: CertificateInfo) => product.address === address,
    ),
};

// mutations
const mutations = {
    [MUTATE_PRODUCTS](state: ProductStore, payload: CertificateInfo[]) {
        state.products = payload;
    },
    [DELETE_PRODUCT](state: ProductStore, id: number) {
        const index = findIndex(state.products, product => product.id === id);
        state.products.splice(index, 1);
    },
};

// actions
const actions = {
    [MUTATE_PRODUCTS](context: any, payload: any) {
        context.commit(MUTATE_PRODUCTS, payload);
    },
};


export default {
    state: productState,
    getters,
    actions,
    mutations,
};
